import { TRootState } from 'Redux/Reducers';

export const getRedeemVoucher = (state: TRootState) => state.payment.redeemVoucher;
